import { createFeature, createReducer, on } from '@ngrx/store';
import { StatusActions } from './status.actions';
import { LoadingState, StatusState } from '~shared/models/status-state';
import { DeviceStatus } from '~status/models/device-status';

export const statusFeatureKey = 'status';

export interface DeviceStatusState {
    status: StatusState;
    data: DeviceStatus | null;
    loadTime: string | null;
    errorMsg: string | null;
    qrScanner: boolean;
    attachmentsBusy: boolean;
    impersonation: { email: string, token: string };
}

export const initialState: DeviceStatusState = {
    status: LoadingState.default,
    data: null,
    loadTime: null,
    errorMsg: null,
    qrScanner: false,
    attachmentsBusy: false,
    impersonation: { email: '', token: '' },
};

export const statusReducer = createReducer(
    initialState,
    on(StatusActions.loadDeviceStatus, (state, { silent }) => ({
        ...state,
        status: silent ? LoadingState.refreshing : LoadingState.loading,
        errorMsg: null,
    })),
    on(StatusActions.loadDeviceStatusSuccess, (state, {data}) => ({
        ...state,
        status: LoadingState.default,
        data,
        errorMsg: null,
        loadTime: new Date().toISOString(),
    })),
    on(StatusActions.loadDeviceStatusFailure, (state,{error}) => ({
        ...state,
        status: LoadingState.default,
        data: null,
        errorMsg: error,
    })),
    on(StatusActions.loadImpersonationToken, (state) => ({
        ...state,
        status: LoadingState.loading,
        errorMsg: null,
        impersonation: {email: '', token: ''},
    })),
    on(StatusActions.loadImpersonationTokenSuccess, (state, {email, token}) => ({
        ...state,
        status: LoadingState.default,
        errorMsg: null,
        impersonation: {email, token},
    })),
    on(StatusActions.loadImpersonationTokenFailure, (state,{error}) => ({
        ...state,
        status: LoadingState.default,
        errorMsg: error,
        impersonation: {email: '', token: ''},
    })),
    on(StatusActions.deleteAttachment, (state) => ({
        ...state,
        attachmentsBusy: true,
    })),
    on(StatusActions.uploadAttachmentSuccess, (state, { deviceId, attachment }) => ({
        ...state,
        attachmentsBusy: false,
        data:
            state.data?.id === deviceId
                ? { ...state.data, attachments: [...state.data.attachments, attachment] }
                : state.data,
    })),
    on(StatusActions.deleteAttachmentSuccess, (state, { deviceId, id }) => ({
        ...state,
        attachmentsBusy: false,
        data:
            state.data?.id === deviceId
                ? { ...state.data, attachments: state.data.attachments.filter((a) => a.id !== id) }
                : state.data,
    })),
    on(StatusActions.deleteAttachmentFailure, (state) => ({
        ...state,
        attachmentsBusy: false,
    })),
    on(StatusActions.setQrScannerStatus, (state,{isOpen}) => ({
        ...state,
        qrScanner: isOpen,
    }))
);

export const statusFeature = createFeature({
    name: statusFeatureKey,
    reducer: statusReducer,
});
